document.addEventListener('DOMContentLoaded', function () {
  function openMainAccordions() {
    document
      .querySelectorAll('accordion-disclosure.yg-main-accordion')
      .forEach((accordion) => {
        if (typeof accordion.toggle === 'function') {
          accordion.toggle(true, false);
        }
      });
  }

  if (customElements.get('accordion-disclosure')) {
    openMainAccordions();
  } else {
    customElements.whenDefined('accordion-disclosure').then(openMainAccordions);
  }

  const FIELD_REQUIRED_TEXT = 'The field is required';

  function getFormId(form) {
    return form?.getAttribute?.('id') || '';
  }

  function getProductForm(fromEl) {
    if (
      fromEl instanceof HTMLFormElement &&
      fromEl.matches('form[action*="/cart/add"]')
    ) {
      return fromEl;
    }

    return (
      document.querySelector(
        'product-rerender product-form form[action*="/cart/add"]'
      ) ||
      document.querySelector('product-form form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  function getForceVariantPicker(form) {
    const formId = getFormId(form);
    if (!formId) return null;
    return document.querySelector(
      `variant-picker[form-id="${formId}"][data-force-selection]`
    );
  }

  function getIncompleteForceOptions(picker, form) {
    if (!picker || !form) return [];

    const formId = getFormId(form);
    return Array.from(picker.querySelectorAll('[data-force-option]')).filter(
      (option) => {
        const position = option.getAttribute('data-option-position');
        return !document.querySelector(
          `input[data-option-position="${position}"][form="${formId}"]:checked`
        );
      }
    );
  }

  function getVisibleGloboOptionBlocks() {
    return Array.from(
      document.querySelectorAll(
        '.globo-swatch-product-detail .swatch--gl, .globo-swatch-product-detail [data-option-index]'
      )
    ).filter((block) => {
      const style = window.getComputedStyle(block);
      return (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        block.offsetParent !== null
      );
    });
  }

  function isGloboOptionSelected(block) {
    if (
      block.querySelector(
        'input:checked, .selected, .active, .is-selected, li.selected'
      )
    ) {
      return true;
    }

    const valueEl = block.querySelector(
      '.dropdown-button-gsw__value, .globo-selected-value, .name-variant'
    );
    const valueText = valueEl?.textContent?.trim() || '';
    if (!valueText) return false;

    return !/select an? option|select a |choose|选择/i.test(valueText);
  }

  function clearGloboOptionErrors() {
    document
      .querySelectorAll('.globo-swatch-product-detail .yg-force-error')
      .forEach((el) => {
        el.remove();
      });
    document
      .querySelectorAll(
        '.globo-swatch-product-detail .is-invalid, .globo-swatch-product-detail .yg-force-invalid'
      )
      .forEach((el) => {
        el.classList.remove('is-invalid', 'yg-force-invalid');
      });
    document
      .querySelectorAll('.globo-swatch-product-detail .errorOptions')
      .forEach((el) => {
        if (el.dataset.ygForceError === 'true') {
          el.textContent = '';
          el.style.display = '';
          delete el.dataset.ygForceError;
        }
      });
  }

  function showGloboOptionErrors(blocks) {
    blocks.forEach((block) => {
      block.classList.add('yg-force-invalid');
      block
        .querySelector('.dropdown-selector, .dropdown-button-gsw')
        ?.classList.add('yg-force-invalid');

      let error = block.querySelector('.errorOptions');
      if (error) {
        error.dataset.ygForceError = 'true';
        error.textContent = FIELD_REQUIRED_TEXT;
        error.style.display = 'block';
        error.style.color = '#d72c0d';
        error.style.fontSize = '14px';
        error.style.fontWeight = '500';
        error.style.marginTop = '6px';
      } else {
        error = block.querySelector('.yg-force-error');
        if (!error) {
          error = document.createElement('p');
          error.className = 'yg-force-error';
          error.style.cssText =
            'color:#d72c0d;font-size:14px;font-weight:500;line-height:1.4;margin:6px 0 0;';
          block.appendChild(error);
        }
        error.textContent = FIELD_REQUIRED_TEXT;
      }
    });
  }

  function clearForceOptionErrors(picker) {
    picker
      ?.querySelectorAll('[data-force-option].is-invalid')
      .forEach((option) => {
        option.classList.remove('is-invalid');
        const error = option.querySelector('.variant-picker__option-error');
        if (error) {
          error.hidden = true;
          error.setAttribute('hidden', '');
          error.style.display = '';
        }
      });
  }

  function updateForceOptionLabel(option, input) {
    const label = option.querySelector('button.select span');
    if (!label || !input) return;

    const optionLabel = input.closest('label')?.querySelector('span');
    if (optionLabel) {
      label.textContent = optionLabel.textContent.trim();
    }
  }

  function showForceOptionErrors(targets) {
    targets.forEach((option) => {
      option.classList.add('is-invalid');
      const error = option.querySelector('.variant-picker__option-error');
      if (error) {
        error.hidden = false;
        error.removeAttribute('hidden');
        error.style.display = 'block';
      }
    });
  }

  function scrollToTarget(target) {
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    target
      .querySelector('button.select, .dropdown-button-gsw, .dropdown-selector')
      ?.focus?.({
        preventScroll: true
      });
  }

  function getFallbackVariantId(form) {
    const idInput = form?.querySelector?.('[name="id"]');
    if (!idInput) return '';
    return (
      idInput.getAttribute('data-yg-fallback-variant-id') ||
      idInput.defaultValue ||
      ''
    );
  }

  function ensurePaymentButtonVariantId(form) {
    const productForm = getProductForm(form) || form;
    if (!productForm) return;
    const idInput = productForm.querySelector('[name="id"]');
    if (!idInput) return;

    const fallbackId = getFallbackVariantId(productForm);
    if (!fallbackId) return;

    if (!idInput.getAttribute('data-yg-fallback-variant-id')) {
      idInput.setAttribute('data-yg-fallback-variant-id', fallbackId);
    }

    // 未选齐规格时也保留 id，让 Shop Pay 保持可点击深色
    if (!idInput.value) {
      idInput.value = fallbackId;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function validateForcedVariantSelection(form) {
    const productForm = getProductForm(form);
    if (!productForm) return true;

    const picker = getForceVariantPicker(productForm);
    const variantId = productForm.querySelector('[name="id"]')?.value;
    const globoBlocks = getVisibleGloboOptionBlocks();
    const incompleteGlobo = globoBlocks.filter(
      (block) => !isGloboOptionSelected(block)
    );

    clearForceOptionErrors(picker);
    clearGloboOptionErrors();

    // GLO 替换了主题变体选择器时，优先校验可见的 GLO 选项
    if (globoBlocks.length > 0) {
      if (incompleteGlobo.length === 0 && variantId) {
        return true;
      }

      // 校验失败时仍保持 Shop Pay 实色
      ensurePaymentButtonVariantId(productForm);

      const targets =
        incompleteGlobo.length > 0
          ? incompleteGlobo
          : globoBlocks.filter((block) =>
              /size/i.test(
                block.querySelector(
                  '.name-option, legend, .dropdown-button-gsw__value'
                )?.textContent || ''
              )
            );

      const finalTargets =
        targets.length > 0
          ? targets
          : incompleteGlobo.length
            ? incompleteGlobo
            : [globoBlocks[0]];
      showGloboOptionErrors(finalTargets);
      scrollToTarget(finalTargets[0]);
      return false;
    }

    if (!picker) return true;

    const incompleteOptions = getIncompleteForceOptions(picker, productForm);
    if (incompleteOptions.length === 0 && variantId) {
      return true;
    }

    ensurePaymentButtonVariantId(productForm);

    const targets =
      incompleteOptions.length > 0
        ? incompleteOptions
        : Array.from(picker.querySelectorAll('[data-force-option]'));

    if (targets.length === 0) {
      scrollToTarget(picker);
      return false;
    }

    showForceOptionErrors(targets);
    scrollToTarget(targets[0]);
    return false;
  }

  // 供底部导航等自定义加购按钮复用
  window.YGForceVariant = {
    validate: validateForcedVariantSelection,
    getProductForm,
    ensurePaymentButtonVariantId
  };

  // 进入页面即保证 Shop Pay 有可用 variant id（保持深色可点）
  document
    .querySelectorAll('form[action*="/cart/add"]')
    .forEach((form) => ensurePaymentButtonVariantId(form));

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (
        !(form instanceof HTMLFormElement) ||
        !form.matches('form[action*="/cart/add"]')
      ) {
        return;
      }

      if (!validateForcedVariantSelection(form)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const submitter = event.target.closest(
        [
          'button[type="submit"]',
          'input[type="submit"]',
          '.yg-add-to-cart',
          '.yg-add-to-cart button',
          '.yg-buy-it-now-button',
          '.yg-buy-it-now-overlay',
          '.yg-buy-it-now',
          '.shopify-payment-button__button',
          '.shopify-payment-button__more-options',
          '.product-sticky-bar button'
        ].join(',')
      );
      if (!submitter) return;

      // 底部导航 Buy it Now 不在这里拦截，交给各自逻辑，但仍做变体校验
      const form =
        submitter.form ||
        (submitter.getAttribute('form')
          ? document.forms[submitter.getAttribute('form')]
          : null) ||
        submitter.closest('form') ||
        getProductForm(submitter);

      if (!(form instanceof HTMLFormElement)) return;

      if (
        !form.matches('form[action*="/cart/add"]') &&
        !submitter.closest(
          '.yg-add-to-cart, .yg-buy-it-now, .yg-buy-it-now-button, .shopify-payment-button, .product-sticky-bar'
        )
      ) {
        return;
      }

      const productForm = getProductForm(form) || form;
      if (!validateForcedVariantSelection(productForm)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      const input = event.target;
      if (
        !(input instanceof HTMLInputElement) ||
        !input.matches('input[data-option-position]')
      ) {
        return;
      }

      const formId = input.getAttribute('form');
      const form = (formId && document.forms[formId]) || input.form;
      const picker = getForceVariantPicker(form);
      if (!picker || !form) return;

      const forceOption = picker.querySelector(
        `[data-force-option][data-option-position="${input.getAttribute('data-option-position')}"]`
      );

      if (forceOption) {
        forceOption.classList.remove('is-invalid');
        const error = forceOption.querySelector(
          '.variant-picker__option-error'
        );
        if (error) {
          error.hidden = true;
          error.setAttribute('hidden', '');
          error.style.display = '';
        }
        updateForceOptionLabel(forceOption, input);
      }

      const incompleteOptions = getIncompleteForceOptions(picker, form);
      if (incompleteOptions.length > 0) {
        event.stopImmediatePropagation();
        const idInput = form.querySelector('[name="id"]');
        // 不清空 id，保持 Shop Pay 深色可点外观；真实下单仍走校验
        if (idInput && !idInput.value) {
          idInput.value =
            idInput.getAttribute('data-yg-fallback-variant-id') || '';
        }
      }
    },
    true
  );

  // GLO 选择后清掉错误提示
  document.addEventListener(
    'click',
    (event) => {
      const option = event.target.closest(
        '.globo-swatch-product-detail .swatches-options, .globo-swatch-product-detail .select-option, .globo-swatch-product-detail li'
      );
      if (!option) return;
      clearGloboOptionErrors();
      document.querySelectorAll('yg-buy-it-now').forEach((el) => {
        if (typeof el.syncOverlayState === 'function') {
          requestAnimationFrame(() => el.syncOverlayState());
        }
      });
    },
    true
  );

  class YGBuyItNow extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.overlay = this.querySelector('.yg-buy-it-now-overlay');
      this.overlay?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.handleOverlayClick();
      });

      // 捕获原生 Shop Pay 点击，未选规格时先校验
      this.addEventListener(
        'click',
        (event) => {
          if (event.target.closest('.yg-buy-it-now-overlay')) return;
          if (this._passThrough) return;

          const paymentTarget = event.target.closest(
            [
              '.shopify-payment-button__button',
              '.shopify-payment-button__more-options',
              'shopify-accelerated-checkout',
              'shopify-buy-it-now-button'
            ].join(',')
          );
          if (!paymentTarget) return;

          const form = this.getForm();
          if (form && !validateForcedVariantSelection(form)) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        },
        true
      );

      this.syncOverlayState();
      ensurePaymentButtonVariantId(this.getForm());

      this._observer = new MutationObserver(() => {
        ensurePaymentButtonVariantId(this.getForm());
        this.syncOverlayState();
      });
      this._observer.observe(this, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class']
      });

      // 监听 id 被清空时立刻补回，避免 Shop Pay 变浅
      const form = this.getForm();
      const idInput = form?.querySelector?.('[name="id"]');
      if (idInput) {
        this._idObserver = new MutationObserver(() => {
          if (!this.isSelectionComplete()) {
            ensurePaymentButtonVariantId(form);
          }
        });
        this._idObserver.observe(idInput, {
          attributes: true,
          attributeFilter: ['value']
        });
        idInput.addEventListener('change', () => {
          if (!idInput.value && !this.isSelectionComplete()) {
            ensurePaymentButtonVariantId(form);
          }
          this.syncOverlayState();
        });
      }

      document.addEventListener('variant:change', this._onVariantChange);
      document.addEventListener('change', this._onFormChange, true);
    }

    disconnectedCallback() {
      this._observer?.disconnect();
      this._idObserver?.disconnect();
      document.removeEventListener('variant:change', this._onVariantChange);
      document.removeEventListener('change', this._onFormChange, true);
    }

    constructor() {
      super();
      this._onVariantChange = () => this.syncOverlayState();
      this._onFormChange = (event) => {
        if (
          event.target?.matches?.(
            'input[name="id"], input[data-option-position], select'
          )
        ) {
          this.syncOverlayState();
        }
      };
    }

    getForm() {
      return (
        this.closest('form') ||
        this.closest('product-form')?.querySelector('form') ||
        getProductForm(this)
      );
    }

    isSelectionComplete() {
      const form = this.getForm();
      if (!form) return true;
      // 只检查选项是否选齐，不依赖 id 是否为空（id 会保留以维持 Shop Pay 实色）
      const productForm = getProductForm(form) || form;
      const picker = getForceVariantPicker(productForm);
      const globoBlocks = getVisibleGloboOptionBlocks();
      const incompleteGlobo = globoBlocks.filter(
        (block) => !isGloboOptionSelected(block)
      );

      if (globoBlocks.length > 0) {
        return incompleteGlobo.length === 0;
      }

      if (!picker) {
        return !!productForm.querySelector('[name="id"]')?.value;
      }

      const incompleteOptions = getIncompleteForceOptions(picker, productForm);
      return incompleteOptions.length === 0;
    }

    syncOverlayState() {
      const ready = this.isSelectionComplete();
      this.classList.toggle('is-ready', ready);
      if (this.overlay) {
        this.overlay.hidden = ready;
        this.overlay.tabIndex = ready ? -1 : 0;
      }
    }

    getPaymentTrigger() {
      return (
        this.querySelector('.shopify-payment-button__button:not([disabled])') ||
        this.querySelector('.shopify-payment-button__more-options') ||
        this.querySelector('shopify-accelerated-checkout') ||
        this.querySelector('.shopify-payment-button__button') ||
        this.querySelector('shopify-buy-it-now-button button') ||
        this.querySelector('shopify-accelerated-checkout [role="button"]')
      );
    }

    handleOverlayClick() {
      const form = this.getForm();
      if (form && !validateForcedVariantSelection(form)) {
        this.syncOverlayState();
        return;
      }

      this.syncOverlayState();
      this.triggerPayment();
    }

    triggerPayment() {
      const buyBtn = this.getPaymentTrigger();
      if (!buyBtn) return;

      this._passThrough = true;
      try {
        if (typeof buyBtn.click === 'function') {
          buyBtn.click();
        } else {
          buyBtn.dispatchEvent(
            new MouseEvent('click', { bubbles: true, cancelable: true })
          );
        }
      } finally {
        requestAnimationFrame(() => {
          this._passThrough = false;
        });
      }
    }
  }

  if (!window.customElements.get('yg-buy-it-now')) {
    window.customElements.define('yg-buy-it-now', YGBuyItNow);
  }
});
!(function () {
  let e = (e) =>
      !(function e(t) {
        if (t.length % 4 != 0 || !/^[A-Za-z0-9+/=]+$/.test(t)) return !1;
        try {
          return (atob(t), !0);
        } catch (r) {
          return !1;
        }
      })(e)
        ? e
        : decodeURIComponent(escape(window.atob(e))),
    t = {
      is_mark: 'F',
      shop_domain: window?.Shopify?.shop || '',
      watermark_text: e('5rC05Y2w5paH5pys'),
      watermark_size: '20px',
      watermark_color: '#333333'
    },
    r = `${e('aHR0cHM6Ly9haXMueWlndW90ZWNoLmNvbS9zaXRlbWFyay9wcm90ZWN0aW9uL2FwaS92MS93YXRlcm1hcms=')}?shop_domain=${t.shop_domain}`,
    i = () => {
      fetch(r).then((e) => {
        e.json().then((e) => {
          'success' === e.result &&
            ((t = { ...t, ...e, expire_time: Date.now() + 864e5 }),
            'T' === e.is_mark && n(t),
            localStorage.setItem('sitemark_watermark', JSON.stringify(t)));
        });
      });
    },
    s = null,
    n = (e) => {
      if (s) {
        s.disconnect();
        return;
      }
      let { watermark_text: t, watermark_size: r, watermark_color: i } = e,
        o = document.createElement('div');
      ((o.style.position = 'absolute'),
        (o.style.zIndex = '9999'),
        (o.style.left = '50%'),
        (o.style.bottom = '0'),
        (o.style.fontSize = r),
        (o.style.color = i),
        (o.innerHTML = t),
        setTimeout(() => {
          let t = document.querySelector('footer');
          t
            ? ((t.style.position = 'relative'),
              t.appendChild(o),
              (s = new MutationObserver((t) => {
                (s.disconnect(), (s = null), n(e));
              })).observe(t, { attributes: !0, childList: !0, subtree: !0 }))
            : ((o.style.position = 'fixed'), document.body.appendChild(o));
        }, 1e3));
    },
    o = localStorage.getItem('sitemark_watermark');
  if (o) {
    let a = JSON.parse(o);
    ((t = { ...t, ...a }),
      a.expire_time && a.expire_time < Date.now()
        ? i()
        : 'T' === a.is_mark && n(t));
  } else i();
})();

(function () {
  function normalizeWishlistCount(countEl) {
    if (!countEl) return;

    const hasAppBadgeStyles =
      countEl.style.backgroundColor ||
      countEl.style.background ||
      countEl.style.borderRadius ||
      countEl.style.minWidth ||
      countEl.style.width ||
      countEl.style.height ||
      countEl.style.padding ||
      countEl.style.color;

    if (!hasAppBadgeStyles && countEl.dataset.ygWishlistStyled === 'true')
      return;

    countEl.style.removeProperty('background');
    countEl.style.removeProperty('background-color');
    countEl.style.removeProperty('border-radius');
    countEl.style.removeProperty('min-width');
    countEl.style.removeProperty('width');
    countEl.style.removeProperty('height');
    countEl.style.removeProperty('padding');
    countEl.style.removeProperty('padding-inline');
    countEl.style.removeProperty('padding-block');
    countEl.style.removeProperty('color');

    countEl.dataset.ygWishlistStyled = 'true';
  }

  function normalizeAllWishlistCounts() {
    document
      .querySelectorAll(
        '.header__wishlist-link .yg-wishlist-count, .header__wishlist-link .wishlist-total-count'
      )
      .forEach(normalizeWishlistCount);
  }

  function observeWishlistCounts() {
    normalizeAllWishlistCounts();

    document.querySelectorAll('.header__wishlist-link').forEach((link) => {
      new MutationObserver(() => {
        requestAnimationFrame(normalizeAllWishlistCounts);
      }).observe(link, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });

    let attempts = 0;
    const retryTimer = window.setInterval(() => {
      normalizeAllWishlistCounts();
      attempts += 1;
      if (attempts >= 10) window.clearInterval(retryTimer);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeWishlistCounts);
  } else {
    observeWishlistCounts();
  }
})();

(function () {
  document.addEventListener(
    'click',
    function (event) {
      if (
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      const target = event.target;
      if (!(target instanceof Element)) return;

      const link = target.closest('a[href*="#looxReviews"]');
      const modal = link && link.closest('quick-buy-modal');
      if (!link || !modal) return;

      const href = link.getAttribute('href') || '';
      let destination = link.href;

      if (href.charAt(0) === '#') {
        const handle = modal.getAttribute('handle');
        if (!handle) return;

        const productHandle = handle.split('?')[0];
        const root =
          (window.Shopify &&
            window.Shopify.routes &&
            window.Shopify.routes.root) ||
          '/';
        destination = root + 'products/' + productHandle + '#looxReviews';
      }

      event.preventDefault();
      event.stopPropagation();
      window.location.assign(destination);
    },
    true
  );

  function alignProductReviews() {
    const hash = window.location.hash;
    if (hash !== '#looxReviews' && hash !== '#looxReviewsFrame') return 'stop';
    if (alignProductReviews.userScrolled) return 'stop';

    const target =
      document.getElementById('looxReviews') ||
      document.getElementById('looxReviewsFrame');
    if (!target) return 'wait';

    const padding =
      parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) ||
      0;
    if (Math.abs(target.getBoundingClientRect().top - padding) >= 8) {
      target.scrollIntoView({ block: 'start' });
    }

    const aligned = Math.abs(target.getBoundingClientRect().top - padding) < 8;

    return target.getBoundingClientRect().height > 400 && aligned
      ? 'stop'
      : 'wait';
  }

  function watchProductReviewsAnchor() {
    const hash = window.location.hash;
    if (hash !== '#looxReviews' && hash !== '#looxReviewsFrame') return;

    const markUserScroll = () => {
      alignProductReviews.userScrolled = true;
    };

    window.addEventListener('wheel', markUserScroll, { passive: true });
    window.addEventListener('touchmove', markUserScroll, { passive: true });
    window.addEventListener('keydown', (event) => {
      if (
        [
          'ArrowDown',
          'ArrowUp',
          'PageDown',
          'PageUp',
          'Home',
          'End',
          ' '
        ].includes(event.key)
      ) {
        markUserScroll();
      }
    });

    let attempts = 0;
    const retry = () => {
      const state = alignProductReviews();
      attempts += 1;
      if (state === 'wait' && attempts < 12) {
        window.setTimeout(retry, 300);
      }
    };

    if (document.readyState === 'complete') retry();
    else window.addEventListener('load', retry);
  }

  watchProductReviewsAnchor();
})();

(function () {
  function frameSwatchUrl(url) {
    if (!url) return '';
    if (url.includes('cdn.shopify.com') && !/[?&]width=/.test(url)) {
      return url + (url.includes('?') ? '&' : '?') + 'width=180';
    }
    return url;
  }

  function getFrameSwatchMap() {
    const options = window.globo_sw_options;
    if (!options) return null;

    const list = Array.isArray(options) ? options : Object.values(options);
    const map = new Map();

    list.forEach((option) => {
      (option.option_items || []).forEach((item) => {
        const label = String(item?.value || '')
          .trim()
          .toLowerCase();
        const custom = item?.custom || {};
        const url = frameSwatchUrl(
          custom.upload_file?.server_url || custom.image_url?.server_url || ''
        );
        if (label && url) map.set(label, url);
      });
    });

    return map.size ? map : null;
  }

  function applyQuickBuyFrameSwatches(modal) {
    const map = getFrameSwatchMap();
    if (!map || !modal) return;

    modal.querySelectorAll('.thumbnail-swatch').forEach((swatch) => {
      const label = (
        swatch.querySelector('.sr-only')?.textContent ||
        swatch.querySelector('.yg-option-title')?.textContent ||
        ''
      )
        .trim()
        .toLowerCase();
      const url = map.get(label);
      const img = swatch.querySelector('img');
      if (!url || !img || img.dataset.ygFrameSrc === url) return;

      img.dataset.ygFrameSrc = url;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = url;
      img.alt = label;
    });
  }

  function watchQuickBuyFrames(modal) {
    applyQuickBuyFrameSwatches(modal);
    if (modal.dataset.ygFrameObserver === 'true') return;

    modal.dataset.ygFrameObserver = 'true';
    const observer = new MutationObserver(() => {
      applyQuickBuyFrameSwatches(modal);
    });
    observer.observe(modal, { childList: true, subtree: true });
    modal.addEventListener(
      'dialog:after-hide',
      () => {
        observer.disconnect();
        delete modal.dataset.ygFrameObserver;
      },
      { once: true }
    );
  }

  function scheduleQuickBuyFrames(modal) {
    if (!(modal instanceof HTMLElement)) return;

    const tryApply = (attempt) => {
      if (!modal.isConnected) return;
      if (modal.querySelector('.thumbnail-swatch')) {
        watchQuickBuyFrames(modal);
        return;
      }
      if (attempt < 24) window.setTimeout(() => tryApply(attempt + 1), 150);
    };

    tryApply(0);
  }

  // dialog:after-show 默认不冒泡，必须在捕获阶段监听
  document.addEventListener(
    'dialog:after-show',
    (event) => {
      const modal = event.target;
      if (
        !(modal instanceof HTMLElement) ||
        modal.tagName !== 'QUICK-BUY-MODAL'
      ) {
        return;
      }
      scheduleQuickBuyFrames(modal);
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest?.(
        '.product-card__quick-add-button[aria-controls]'
      );
      if (!button) return;
      const modal = document.getElementById(
        button.getAttribute('aria-controls')
      );
      scheduleQuickBuyFrames(modal);
    },
    true
  );
})();
